import STORAGE_KEYS from '../../../Storage/storageKeys';

const { EPG } = STORAGE_KEYS.API_CACHE;

const channelIdsKey = `${EPG}-channelIds`;

const channelKey = (channelId) => `${EPG}-${channelId}`;

// Set is used to filter duplicate IDs
export const mergeAndFilterDuplicates = (current, next) => [...new Set([...current, ...next])];

export const storeEpg = async (storage, epg) => {
    const channelIds = Object.keys(epg);
    const currentChannelIds = await storage.getItem(channelIdsKey);
    const mergedChannelIds = mergeAndFilterDuplicates(currentChannelIds?.data || [], channelIds);
    await storage.setItem(channelIdsKey, { data: mergedChannelIds });
    return Promise.all(
        channelIds.map((channelId) =>
            storage.setItem(channelKey(channelId), { data: epg[channelId] })
        )
    );
};

export const loadEpg = async (storage) => {
    let channelIds = await storage.getItem(channelIdsKey);
    channelIds = channelIds?.data || [];
    return channelIds.reduce(async (epgPromise, channelId) => {
        const channelPromise = storage.getItem(channelKey(channelId));
        const [epg, channel] = await Promise.all([epgPromise, channelPromise]);
        return { ...epg, [channelId]: channel.data };
    }, {});
};

export const clearEpgStorage = async (storage) => {
    const channelIds = (await storage.getItem(channelIdsKey)) || [];
    if (channelIds.data && channelIds.data.length) {
        await storage.removeItem(channelIdsKey);
        return Promise.all(
            channelIds?.data?.map((channelId) => storage.removeItem(channelKey(channelId)))
        );
    }
    return Promise.resolve();
};
